import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { Theme } from "@twilio-paste/core/theme";
import { Box } from "@twilio-paste/core";

import App from "./components/App";
import styles from "../src/styles";
import registerServiceWorker from "./serviceWorker";

ReactDOM.render(
  <Box style={styles.app}>
    <React.StrictMode>
      <Provider store={store}>
        <Theme.Provider theme="twilio">
          <Box style={styles.appWrapper}>
            <App />
          </Box>
        </Theme.Provider>
      </Provider>
    </React.StrictMode>
  </Box>,
  document.getElementById("root")
);

registerServiceWorker().catch(() => {
  console.warn("Install service worker registration skipped");
});
